module.exports = __webpack_public_path__ + "static/img/2.a1b2392.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/hnweR404A/2.jpg
// module id = QoqH
// module chunks = 1